<template>
  <div class="mt-5">
    <p
      class="font-weight-medium ml-5 mb-0"
      style="font-size: 20px"
    >
      
      Similar Stocks <span id='similarStocks'></span> (Usually bought together)
    </p>

    <div v-if="listLoad" :class="{'d-flex flex-wrap justify-center': $vuetify.breakpoint.mdAndUp}">
      <v-skeleton-loader type="card" width="200" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card" width="200" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card" width="200" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card" width="200" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="card" width="200" height="160" class="d-block mr-4 mb-3"></v-skeleton-loader>
    </div>

    <div v-if="!listLoad" class="mx-5 body-1">{{text}}</div>
    <div
      v-if="!listLoad"
      :class="{'d-flex flex-wrap justify-space-around': $vuetify.breakpoint.mdAndUp}"
    >
      <v-row>
        <v-col xs="12" sm="6" md="4" lg="3" v-for="item in stocks" :key="item.id">
          <v-card height="160" class="d-flex flex-column pa-3">
            <v-toolbar style="flex:0" height="auto" color="#233767" dark dense flat>
              <span class="mr-3 d-inline-block text-truncate">{{ item.name }} - {{ item.ticker }}</span>
              <v-spacer></v-spacer>

              <v-btn icon>
                <v-menu offset-x>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(menuitem, i) in menuItems"
                      :key="i"
                      @click="goToStock(item.ric)"
                    >
                      <v-list-item-title>{{ menuitem.title }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>

                      <v-list-item-content>Rate the stock</v-list-item-content>
                      <v-list-item-icon>
                        <stock-set-preference :stock="item.id" :rating="item.preference"></stock-set-preference>
                      </v-list-item-icon>                      
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-btn>
            </v-toolbar>

            <div class="ma-auto text-center">
              <star-rating
                :rounded-corners="false"
                :rating="item.rating"
                :padding="10"
                active-color="#cc1166"
                inactive-color="#13305C"
                border-color="#233767"
                :border-width="3"
                :increment="0.01"
                :star-size="20"
                :inline="true"
                :show-rating="false"
                :read-only="true"
              ></star-rating>
            </div>

            <div class="text-center mt-auto mb-2">
              <span class="font-weight-light">Days to trade: {{ item.days_to_trade }}</span>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockAnalyzeComponentSimilarStocks",
  props: ["stock"],
  components: {
    StockSetPreference: () => import("@/components/SetPreferences"),
  },
  data() {
    return {
      menuItems: [
        {
          title: "Go to stock page",
          path: "/stocks/analyze/",
        },
      ],
      stocks: [],
      text: "",
      aggregateExpo: [],
      listLoad: true,
      errorbar: false,
    };
  },
  mounted() {
    this.getListFromApi();
  },
  methods: {
    goToStock(id) {
      this.$router.push({ name: "StocksAnalyze", params: { stock: id } });
    },
    formatNumber(nb) {
      if (typeof nb === "string") {
        return nb;
      } else {
        return nb.toFixed(2);
      }
    },
    async getListFromApi() {
      var self = this;
      const currentSession = await this.$Amplify.Auth.currentSession();
      const currentToken = currentSession.getIdToken().getJwtToken();
      this.$http
        .get(
          process.env.VUE_APP_API_HOST +
            "/get-stock-similar-stocks/" +
            self.stock,
          {
            headers: {
              Authorization: currentToken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(function (response) {
          //console.log(response.data)
          self.stocks = response.data.similar_stocks;
          self.text = response.data.text;
          self.aggregateExpo = response.data.agg;
          self.listLoad = false;
        })
        .catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false;
          //self.errorbar = true
        });
    },
  },
};
</script>

<style scoped lang="sass">
.card-width
  width: 200px
</style>